export const removeDuplicatedCategories = categories => {
    const newCategories = []
    categories &&
        categories.forEach(category => {
            if (newCategories.indexOf(category.name) === -1)
                newCategories.push(category.name)
        })
    return newCategories
}
